import { Component, ViewChild, OnInit } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatBadgeModule } from '@angular/material/badge';
import { CommonModule } from '@angular/common';


export interface Fonts {
  id: number;
  fav: string;
  name: string;
  data: string;
  vig: boolean;
  clicked: boolean;
}

export interface FontsFav {
  id: number;
  fav: string;
  name: string;
  data: string;
  vig: boolean;
  clicked: boolean;
}

const ELEMENT_DATA: Fonts[] = [
  { id: 1, fav: '', name: 'BCRA', data: '18', vig: true, clicked: false },
  { id: 2, fav: '', name: 'Direccion Electronica', data: '17', vig: true, clicked: false },
  { id: 3, fav: '', name: 'Cheques Rechazados', data: '16', vig: true, clicked: false },
  { id: 4, fav: '', name: 'Consultas', data: '16', vig: true, clicked: false },
  { id: 5, fav: '', name: 'Boureau', data: '15', vig: false, clicked: false },
  { id: 6, fav: '', name: 'Relaciones', data: '12', vig: false, clicked: false },
  { id: 7, fav: '', name: 'Otras fuentes', data: '1', vig: true, clicked: false },
  { id: 8, fav: '', name: 'Informes', data: '1', vig: false, clicked: false },
  { id: 9, fav: '', name: 'Observaciones Salud', data: '1', vig: true, clicked: false },
  { id: 10, fav: '', name: 'Ref. comercial', data: '10', vig: true, clicked: false },
  { id: 11, fav: '', name: 'Pla.Persona', data: '', vig: false, clicked: false },
  { id: 12, fav: '', name: 'Observaciones Telco', data: '', vig: false, clicked: false },
  { id: 13, fav: '', name: 'Textos', data: '', vig: false, clicked: false },
  { id: 14, fav: '', name: 'Observaciones', data: '', vig: false, clicked: false }
];

const ELEMENT_DATA_FAV: Fonts[] = [];


@Component({
    selector: 'app-tabs-sources',
    templateUrl: './tabs-sources.component.html',
    styleUrls: ['./tabs-sources.component.scss'],
    standalone: true,
    imports: [CommonModule, MatTableModule, MatSortModule, MatTabsModule, MatFormFieldModule, MatBadgeModule]
})
export class TabsSourcesComponent implements OnInit {

  displayedColumns: string[] = ['fav', 'name', 'data', 'vig'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  selectedFontsFav: any[] = [];
  dataSourceFav = new MatTableDataSource(ELEMENT_DATA_FAV);

  displayedColumnsFav: string[] = ['fav', 'name', 'data', 'vig'];

  constructor() {
    // This is intentional
  }

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = function (data, filter: string): boolean {
      return data.name.toLowerCase().includes(filter);
    };
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }

  applyFilterFav(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSourceFav.filter = filterValue;
  }

  favorite(element: Fonts) {
    element.clicked = !element.clicked;
    if (element.clicked) {
      this.selectedFontsFav.push(element);
    } else {
      const idx = this.selectedFontsFav.indexOf(element);
      if (idx != -1) {
        this.selectedFontsFav.splice(idx, 1);
      }

    }
    this.dataSourceFav = new MatTableDataSource(this.selectedFontsFav);
    this.dataSourceFav.sort = this.sort;
    this.dataSourceFav.filterPredicate = function (dataFav, filter: string): boolean {
      return dataFav.name.toLowerCase().includes(filter);
    };
  }

}
